import Icon from '../../components/Icon'
import type { PublicBadge } from '../../../shared/market/verification'
import { vt } from './strings'
import './verification.css'

/**
 * The public badge. Identity and residency stay separate: pass `kind` for each. It is a ready-made piece
 * for the owner to place on listing cards and the item page; it is not mounted anywhere yet.
 * It shows exactly what was checked and when, and says what it does not mean.
 */
export default function VerifiedBadge({ badge, kind = 'residency' }: { badge: PublicBadge; kind?: 'residency' | 'identity' }) {
  return (
    <details className="v-badge" data-kind={kind}>
      <summary>
        <Icon name="shield" size={16} />
        <span>{vt(kind === 'residency' ? 'badgeText' : 'identityBadgeText')}</span>
      </summary>
      <div className="v-badge-pop" role="note">
        <p><strong>{vt('badgeWhat')}.</strong> {vt('badgeWhatText')}</p>
        <p>{vt('checkedOn')} {badge.checkedOn}{badge.validUntil ? `. ${vt('validUntil')} ${badge.validUntil}.` : '.'}</p>
        <p><strong>{vt('badgeNot')}.</strong> {vt('badgeNotText')}</p>
      </div>
    </details>
  )
}
